const footerData = {
    description: " Subul Contracting. All rights reserved",
    TermsPage: "Terms",
    PrivacyPage: "Privacy"
}

export { footerData }